import * as React from "react";
import { styled } from "@mui/system";
import { MuiTelInput } from 'mui-tel-input';
import { MuiTelInputProps } from 'mui-tel-input';
import Box from "@vapor/react-material/Box";
import FormHelperText from "@vapor/react-material/FormHelperText";

export type PhoneNumberInputProps = {
    readOnly?: boolean;
} & MuiTelInputProps;

  
  export const PhoneNumberInput= styled(
    React.forwardRef<HTMLDivElement, PhoneNumberInputProps>((props, ref) => {
        const helperErrorConst = (
            <Box>
              <FormHelperText
                sx={{
                  "&.MuiFormHelperText-root": {
                    marginTop: 0
                  }
                }}
                error
              >
                {props.helperText}
              </FormHelperText>
            </Box>
          );
        return (
            <MuiTelInput
                spellCheck="false"
                fullWidth
                sx={{
                    "input[type=number]::-webkit-inner-spin-button": {
                    WebkitAppearance: "none",
                    margin: 0
                    },
                    "&.MuiTextField-root": {
                    paddingLeft: 0,
                    paddingRight: 0
                    },
                    "& fieldset": { top: 0 },
                    "& legend": {
                    display: "none"
                    },
                    "& .MuiOutlinedInput-notchedOutline": {
                    top: 0
                    },
                    "fieldset ": {
                    borderColor: props.disabled
                        ? "primary.borderDisabled"
                        : props.error
                        ? "primary.borderError"
                        : "primary.borderDefault",
                    cursor: props.disabled ? "not-allowed" : null,
                    pointerEvents: props.disabled ? "all !important" : null
                    },
                    "& .MuiTelInput-Flag": {
                        opacity: props.disabled ? 0.3 : 1,
                        pointerEvents: props.disabled ? "none" : "auto"
                    },
                }}
                {...props} 
                helperText={
                    props.error && props.helperText ? helperErrorConst : props.helperText
                }
                inputProps={{
                    readOnly: props.readOnly,
                    ...props.inputProps
                  }}
                contentEditable="inherit"
                ref={ref} 
             />
        )
    }),
    {
        name: "PhoneNumberInput",
        slot: "Root",
        overridesResolver: (props, styles) => []
    }
    )(({theme}) => ({
        "& .MuiOutlinedInput-root.Mui-error .MuiOutlinedInput-notchedOutline": {
            borderColor: theme.palette.error.main,
          },
    })
    )


export default PhoneNumberInput;